module.exports = __webpack_public_path__ + "media/images/features/6/schedule-5-b81bdcfcff01fd550b3eead8c825ea36.png";